export class SessionExpiredError extends Error {
  constructor(public readonly originalError: Error) {
    super("Session expired: refresh token is invalid");
    this.name = "SessionExpiredError";
  }
}
